<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="900">
      <v-card light>
        <v-card-title class="headline">Precargar Informe desde Informes Anteriores</v-card-title>
        <v-card-actions>
          <v-flex xs4 ml-3>Seleccionar informe a copiar</v-flex>
          <v-spacer></v-spacer>
          <v-flex xs8 pt-3 mr-5>
            <v-select v-model="informe" label="Informes Anteriores" required :error-messages="informeErrors"
              :items="informes" item-text="mesDisplay" item-value="pk"></v-select>
          </v-flex>
        </v-card-actions>
        <v-card-actions>
          <v-btn color="error" flat @click="dialog = false">Volver</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="submit">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmationDialog ref="confirm" :function-yes="bindingFunction"></ConfirmationDialog>
  </v-layout>
</template>

<script>
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { createEntityMixin } from '../../../mixins/createEntityMixin'

export default {
  components: {
    ConfirmationDialog
  },

  mixins: [validationMixin, createEntityMixin],

  validations: {
    informe: { required }
  },

  data () {
    return {
      dialog: false,
      informe: null,
      informes: [],
      bindingFunction: null,
      isEditing: true
    }
  },

  computed: {
    informeErrors () {
      return this.getRequiredErrors('informe')
    },
    editPath () {
      return `informes/precarga/${this.$route.params.id}`
    }
  },

  methods: {
    setData (data) {
      this.informes = data
    },
    openDialog () {
      this.dialog = true
    },
    submit () {
      if (!this.$v.$invalid) {
        this.$refs.confirm.openDialog()
        this.dialog = false
      }
    }
  },

  created () {
    this.bindingFunction = () => {
      const payload = {
        informe: this.informe
      }
      this.axios
        .put(`/informe/precargar/${this.$route.params.id}`, payload)
        .then(() => this.$emit('precargado'))
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    }
  }
}
</script>
